import { useSelector } from 'react-redux';
import { positionsDateSelector } from '../state/selectors';

export const usePositionsDate = (): string => {
  return useSelector(positionsDateSelector);
};
